import { Dayjs } from 'dayjs';

export type ResponseGeneratedSection = {
  id: number;
  sectionId: number;
  reportId: number;
  createdAt: Dayjs;
  updatedAt: Dayjs;
  title: string;
  content: string;
  prompt: string;
  order: number;
};
export type Section = {
  id: number;
  sectionId: number;
  reportId: number;
  createdAt: Dayjs;
  updatedAt: Dayjs;
  title: string;
  content: string;
  prompt: string;
  order: number;
};
export type ResponseReport = {
  id: number;
  sessionId: number;
  generatedSections: ResponseGeneratedSection[];
  error: string | null;
};

export interface ReportsMixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  getReport(sessionId: number, templateId: number): Promise<ResponseReport>;
  genReport(sessionId: number, templateId: number, reportId: number): Promise<ResponseReport>;
  createReport(sessionId: number, templateId: number): Promise<ResponseReport>;
  reGenReport(sessionId: number, templateId: number, reportId: number): Promise<ResponseReport>;
}
export const ReportsMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async getReport(sessionId: number, templateId: number): Promise<ResponseReport> {
    const report = await this.fetch(`/sessions/${sessionId}/templates/${templateId}/reports`, {
      method: 'get',
    });
    return report;
  },
  async genReport(
    sessionId: number,
    templateId: number,
    reportId: number
  ): Promise<ResponseReport> {
    const report = await this.fetch(
      `/sessions/${sessionId}/templates/${templateId}/reports/${reportId}`,
      { method: 'get' }
    );
    return report;
  },
  async createReport(sessionId: number, templateId: number): Promise<ResponseReport> {
    const report = await this.fetch(`/sessions/${sessionId}/templates/${templateId}/reports`, {
      method: 'post',
    });
    return report;
  },
  async reGenReport(
    sessionId: number,
    templateId: number,
    reportId: number
  ): Promise<ResponseReport> {
    const report = await this.fetch(
      `/sessions/${sessionId}/templates/${templateId}/reports/${reportId}`,
      { method: 'put' }
    );
    return report;
  },
} as ReportsMixin;
